import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import JobBoardLoader from '../Shared/pageLoaderGreen/JobBoardLoader';
import AllApplicationLoading from '../Shared/LoaderBigTwo/AllApplicationLoading';
import GreenSpinner from '../Shared/Loading/GreenSpinner';

const AdminTutors = () => {

    const [tutors, setTutors] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchPhone, setSearchPhone] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [loading, setLoading] = useState(true);

    // Fetch tutors whenever the current page, searchPhone, or searchEmail changes
    useEffect(() => {
        fetchTutors(currentPage, searchPhone, searchEmail);
    }, [currentPage, searchPhone, searchEmail]);

    // Fetch tutors with pagination and search
    const fetchTutors = async (page, phone, email) => {
        try {
            const response = await fetch(`https://tutor-tree-server-1.vercel.app/tutorAdminGreen?page=${page}&phone=${phone}&email=${email}`);
            const data = await response.json();
            setTutors(data.tutors);
            setTotalPages(data.totalPages);
            setLoading(false)
        } catch (error) {
            console.error("Error fetching tutors:", error);
        }
    };

    // Handle page navigation and keep search query intact
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };
    const handleMakeAdmin = (id) => {
        fetch(`https://tutor-tree-server-1.vercel.app/users/admin/${id}`, {
          method: "PUT",
        })
          .then((res) => res.json())
          .then((data) => {
            console.log(data);
            if (data.modifiedCount > 0) {
              toast.success("Make admin successful.");
    
              // Re-fetch the updated user data
              fetchTutors(); // Call the fetchTutors function again to update the user data
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            // Handle any errors that occur during the request
          });
      };
      const handleMakeSuperAdmin = (id) => {
        fetch(`https://tutor-tree-server-1.vercel.app/users/superAdmin/${id}`, {
          method: "PUT",
        })
          .then((res) => res.json())
          .then((data) => {
            console.log(data);
            if (data.modifiedCount > 0) {
              toast.success("Make super admin successful.");
    
              // Re-fetch the updated user data
              fetchTutors(); // Call the fetchTutors function again to update the user data
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            // Handle any errors that occur during the request
          });
      };
      const handleRemoveRole = (id) => {
        fetch(`https://tutor-tree-server-1.vercel.app/users/removeAdmin/${id}`, {
          method: "PUT",
        })
          .then((res) => res.json())
          .then((data) => {
            console.log(data);
            if (data.modifiedCount > 0) {
              toast.success("Remove role successful.");
    
              // Re-fetch the updated user data
              fetchTutors(); // Call the fetchTutors function again to update the user data
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            // Handle any errors that occur during the request
          });
      };
      if (loading) return <GreenSpinner></GreenSpinner>;

    return (
        <div className='flex flex-col justify-between'>
            <div className='w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md'>
                <h2 className='text-xl text600 text-start text-green-900 font-montserrat'>Make Admin</h2>
            </div>

            <div className='bg-green-500 px-5 w-full my-10'>
            <div className='py-2 w-[30%] flex justify-between  my-6'>
                <input
                    type="text"
                    placeholder="Search by Phone"
                    className='border border-green-500 rounded-lg font-montserrat'
                    value={searchPhone}
                    onChange={(e) => {
                        setSearchPhone(e.target.value);
                        setCurrentPage(1); // Reset to first page when search query changes
                    }}
                />
                <input
                    type="text"
                    placeholder="Search by Email"
                    className='border border-green-500 rounded-lg font-montserrat'
                    value={searchEmail}
                    onChange={(e) => {
                        setSearchEmail(e.target.value);
                        setCurrentPage(1); // Reset to first page when search query changes
                    }}
                />
            </div>
            </div>

       
            <div className="w-full bg-white mt-5">
        <div class=" overflow-x-auto h-[600px]">
          <div class="relative  shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-white uppercase bg-green-500 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    #
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Email
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Phone Number
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Role
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Make Admin
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Remove Role (Admin)
                  </th>
                </tr>
              </thead>
              {tutors.map((job, index) => (
                <tbody>
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {index + 1}
                    </th>
                  
                    <td class="px-6 py-4">
                      {job.name} 
                    </td>
                    <td class="px-6 py-4">
                      {job.email} 
                    </td>
                    <td class="px-6 py-4">
                      {job.phone} 
                    </td>
                    <td class="px-6 py-4">
                      {job.role} 
                    </td>
                    <td class="px-2 py-4 ">
                        <td class="px-2 py-4">
                          {job?.role !== "admin" && (
                            <button
                              onClick={() => handleMakeAdmin(job._id)}
                              class="inline-flex items-center px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-md"
                            >
                              <span class="material-symbols-outlined">
                                shield_person
                              </span>
                              MAKE ADMIN
                            </button>
                          )}
                        </td>
                      </td>
                      <td class="px-2 py-4 ">
                        <td class="px-2 py-4">
                          {job?.role !== "removeAdmin" && (
                            <button
                              onClick={() => handleRemoveRole(job._id)}
                              class="inline-flex items-center px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-md"
                            >
                               <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-5 w-5 mr-2"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              />
                            </svg>
                              Remove Role
                            </button>
                          )}
                        </td>
                      </td>
                  </tr>
                </tbody>
              ))}
            </table>
            <div className="flex justify-center items-start ">
              <div className="flex justify-between my-5 w-[300px]">
                <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
                <span className="text-lg font-roboto">
                  Page {currentPage} of {totalPages}
                </span>
                <button onClick={handleNextPage} >
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

        </div>
    );
};

export default AdminTutors;
